@if (systems.length > 0) {
<div class="list">
  <div class="header">
    @if (title == 'Process') {
    <span class="title process-color">process</span>
    } @if (title == 'Utility') {
    <span class="title utility-color">utility</span>
    }
    <button class="iconf-btn-blank" (click)="isSelected ? removeAllSystems.emit(systems) : selectAllSystems.emit(systems)">
      <mat-icon class="mat-icon-blue">check</mat-icon>
      <span>{{ isSelected ? 'remove all' : 'select all' }}</span>
    </button>
  </div>
  <div class="body">
    @for (system of systems; track system) {
    <app-system-card
      [system]="system"
      [isSelected]="isSelected"
      class="item"
      (selectSystem)="selectSystem.emit($event)"
      (removeSystem)="removeSystem.emit($event)"
    >
    </app-system-card>
    }
  </div>
</div>
}
